module.exports = __webpack_public_path__ + "media/images/lov_it3-db3c7f79c5292e08b3fee3af4e5eb799.jpg";